// HomeWeb.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
import { useLogScreen } from '../../useLogScreen';
export default function OneCadastroAnaliseCNPJWeb() {
  useLogScreen('OneCadastroAnalise');
  useEffect(() => {
    if (Platform.OS === 'web') {
      setTimeout(() => {
        document.title = 'imoGo | Dados do proprietário';
      }, 100);
    }
  }, []);
  const navigation = useNavigation();
  // envio unico 

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [usuario_id, setUsuario_id] = useState(null);


  console.log(usuario_id)


  // teste multi forms

  const [proprietarios, setProprietarios] = useState([
    {
      nomeCompleto: '', nomeCompletoMae: '', cpf: ''
    },
  ]);


  const adicionarProprietario = () => {
    setProprietarios([...proprietarios, {
      nomeCompleto: '', nomeCompletoMae: '', cpf: ''
    }]);
  };

  const atualizarProprietario = (index, campo, valor, subcampo = null) => {
    const novosProprietarios = [...proprietarios];
    if (subcampo) {
      novosProprietarios[index][campo][subcampo] = valor; // Atualiza subcampo (cônjuge)
    } else {
      novosProprietarios[index][campo] = valor; // Atualiza campo principal
    }
    setProprietarios(novosProprietarios);
  };
  // end teste 

  // Referências para os inputs
  const nomeCompletoRef = useRef([]);
  const nomeCompletoMaeRef = useRef([]);
  const cpfRef = useRef([]);
  const dataNascimentoRef = useRef([]);

  // Estado dos campos
  const [nomeCompleto, setNomeCompleto] = useState('');
  const [nomeCompletoMae, setNomeCompletoMae] = useState('');
  const [cpf, setCpf] = useState('');

  const nomeCompletoCngRef = useRef([]);
  const nomeCompletoMaeCngRef = useRef([]);
  const cpfCngRef = useRef([]);
  const dataNascimentoCngRef = useRef([]);


  // muie 

  const [nomeCompletoCng, setNomeCompletoCng] = useState('');
  const [nomeCompletoMaeCng, setNomeCompletoMaeCng] = useState('');
  const [cpfCng, setCpfCng] = useState('');


  const [estadoCivil, setEstadoCivil] = useState('');
  const [dataNascimento, setdataNascimento] = useState('');
  const [dataNascimentoCng, setdataNascimentoCng] = useState('');


  const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];


  const [showEstadoCivilOptions, setShowEstadoCivilOptions] = useState(
    proprietarios.map(() => false)
  );

  const estadoCivilOptions = ['solteiro(a)', 'casado(a)', 'viúvo(a)', 'divorciado(a)', 'separado(a)'];

  // Função para selecionar uma opção e fechar a lista  

  const toggleEstadoCivilOptions = (index) => {
    const updatedOptions = [...showEstadoCivilOptions];
    updatedOptions[index] = !updatedOptions[index];
    setShowEstadoCivilOptions(updatedOptions);
  };

  const selectEstadoCivil = (index, option) => {
    atualizarProprietario(index, 'estadoCivil', option); // Atualiza o estado civil no proprietário
    toggleEstadoCivilOptions(index); // Fecha a lista de opções
  };

  // data format 

  const convertDateToISO = (dateString) => {
    // Verifica se a data é uma data 
    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      throw new Error("Data inválida. O formato esperado é DD/MM/YYYY.");
    }

    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  };

  // Validação para habilitar o botão "Salvar"
  // const isFormValid = () => nomeCompleto && proprietarios.cpf && estadoCivil && dataNascimento;

  const isFormValid = () => {
    return proprietarios.every((p) =>
      p.nomeCompleto &&
      p.cpf
    );
  };

  const handleSaveImovel = async () => {

    if (isSubmitting) return; // Previne múltiplos cliques
    setIsSubmitting(true);

    try {
      const dadosFormatados = proprietarios.map((p) => {
        const proprietario = {
          razao_social: p.nomeCompleto,
          nome_fansasia: p.nomeCompletoMae,
          cnpj: p.cpf,
          e_empresa: true,
        };

        return proprietario;
      });

      console.log("Dados formatados: ", dadosFormatados);


      const payload = {
        usuario_id,
        proprietarios: dadosFormatados,
      }

      console.log("Payload: ", payload)

      const response = await axios.post('https://analise3.imogo.com.br/analises/etapa1/cnpj/', [
        {
          usuario_id,
          proprietarios: dadosFormatados,
        }
      ]);

      console.log("Resposta da API:", response.data);

      if (response.status === 200) {
        console.log("Dados enviados com sucesso")
        const { analise_id } = response.data;
        navigation.navigate('EtapasAnaliseCNPJWeb', { usuario_id, analise_id, status: 2 });
      } else {
        throw new Error(`Erro: Código de status ${response.status}`);
      }
      // Alert.alert('Sucesso', 'Dados enviados com sucesso!');
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
      Alert.alert('Erro', 'Não foi possível enviar os dados.');
    }
  };

  return (
    <BaseWeb>
      {(userInfo) => {
        setUsuario_id(userInfo.id)
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados da empresa</Text>

              {proprietarios.map((proprietario, index) => (
                <View key={index} style={styles.proprietarioContainer}>

                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Razão Social</Text>
                    <TouchableWithoutFeedback onPress={() => nomeCompletoRef.current[index]?.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={(ref) => nomeCompletoRef.current[index] = ref} // Configurando o ref dinâmico
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="Razão Social"
                          value={proprietario.nomeCompleto}
                          placeholderTextColor="#A9A9A9"
                          onChangeText={(text) => atualizarProprietario(index, 'nomeCompleto', text)}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>
                  {/* Nome Completo Mae */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>Nome Fantasia (Opcional)</Text>
                    <TouchableWithoutFeedback onPress={() => nomeCompletoMaeRef.current[index]?.focus()}>
                      <View style={styles.inputContainer}>
                        <TextInput
                          ref={(ref) => nomeCompletoMaeRef.current[index] = ref} // Configurando o ref dinâmico
                          allowFontScaling={false}
                          style={styles.areaInput}
                          placeholder="Nome Fantasia"
                          value={proprietario.nomeCompletoMae}
                          placeholderTextColor="#A9A9A9"
                          onChangeText={(text) => atualizarProprietario(index, 'nomeCompletoMae', text)}
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>

                  {/* CPF com máscara */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel} allowFontScaling={false}>CNPJ</Text>
                    <TouchableWithoutFeedback onPress={() => cpfRef.current[index]?.focus()}>
                      <View style={styles.inputContainer}>
                        <MaskInput
                          ref={(ref) => cpfRef.current[index] = ref}
                          allowFontScaling={false}
                          style={styles.areaInput}
                          value={proprietario.cpf}
                          onChangeText={(text) => atualizarProprietario(index, 'cpf', text)}
                          mask={Masks.BRL_CNPJ}
                          placeholderTextColor="#A9A9A9"
                          keyboardType="numeric"
                          placeholder="00.000.000/0000-00"
                        />
                      </View>
                    </TouchableWithoutFeedback>
                  </View>

                  {/* Separador visual (Divisão) */}
                  <View style={styles.divider} />


                </View>
              ))}

              {/* Inputs de Área */}

              <TouchableOpacity style={styles.laterButton} onPress={adicionarProprietario}>
                <Text style={styles.laterButtonText}>Adicionar empresa</Text>
              </TouchableOpacity>
              {/* Botão Salvar */}
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSaveImovel}
                  disabled={!isFormValid() || isSubmitting} // Desabilita durante a submissão
                >
                  <Text style={styles.saveButtonText} allowFontScaling={false}>
                    {isSubmitting ? "Enviando..." : "Salvar"}
                  </Text>
                </TouchableOpacity>

                {/* <TouchableOpacity style={styles.laterButton}>
                  <Image
                    source={require('../../assets/icons/bookmark.png')} // Ícone de terminar mais tarde
                    style={styles.laterIcon}
                  />
                  <Text
                    style={styles.laterButtonText}
                    allowFontScaling={false}
                    onPress={() => navigation.navigate('Home', { usuario_id })}
                  >
                    Terminar mais tarde
                  </Text>
                </TouchableOpacity> */}
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
